import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogTitle, DialogContent, IconButton, Stack, Link, Tooltip, Zoom} from 'views/components';
import {ContentCopy as ContentCopyIcon} from 'views/icons';
import {translate} from 'views/module';

const ShowCustomUrl = (props) => {
  const [isCopying, setIsCopying] = React.useState(false);

  const {
    customUrlRef,
    isShowingCustomUrl,
    setIsShowingCustomUrl,
  } = props;

  const onClose = () => {
    setIsShowingCustomUrl(false);
    customUrlRef.current = ''; // reset it so we don't keep concatenating
  };

  const copyProfileUrl = async () => {
    setIsCopying(true);
    try {
      await window.navigator.clipboard.writeText(customUrlRef.current);
    } catch (err) {
      // silently fail for now
    } finally {
      setTimeout(() => {
        setIsCopying(false);
      }, 1000);
    }
  };

  return (
    <Dialog onClose={onClose} open={isShowingCustomUrl}>
      <DialogTitle onClose={onClose}>
        {translate('caregiver.CaregiverDetail.Settings.ProfileUrl.ShowCustom.Title')}
      </DialogTitle>
      <DialogContent>
        <Stack direction="row" spacing={1} alignItems="center">
          <Link
            href={customUrlRef.current}
            target="_blank"
            rel="noopener"
            sx={{
              fontSize: '14px',
              wordBreak: 'break-all',
              textAlign: 'left',
            }}
          >
            {customUrlRef.current}
          </Link>
          <Tooltip
            title={translate('caregiver.CaregiverDetail.Settings.ProfileUrl.ShowCustom.Copy')}
            placement="top"
            TransitionComponent={Zoom}
          >
            <IconButton onClick={copyProfileUrl}>
              <ContentCopyIcon
                sx={{
                  color: isCopying ? 'secondary.main' : 'inherit',
                }}
              />
            </IconButton>
          </Tooltip>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

ShowCustomUrl.propTypes = {
  customUrlRef: PropTypes.object.isRequired,
  isShowingCustomUrl: PropTypes.bool.isRequired,
  setIsShowingCustomUrl: PropTypes.func.isRequired,
};

export default React.memo(ShowCustomUrl);
